import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { Link } from "../../../../Link";

import type { OmitOfUnion } from "../../../../../types/react";
import type { LinkProps } from "../../../../Link";
import type { AvatarsViewSize } from "../../types";

import classes from "../../AvatarsView.styl";

const AVATARS_VIEW_LINK_TEST_ID = "avatars-view-link-test-id";

type AbsentedProps = "size" | "data-tsid";

export type AvatarsViewLinkProps = OmitOfUnion<LinkProps, AbsentedProps>;
type ContentAvatarsViewLink = LinkProps & { size: AvatarsViewSize };

const AvatarsViewLink: FC<AvatarsViewLinkProps> = (props) => {
    const { children, size } = props as ContentAvatarsViewLink;

    return (
        <Link
            {...props}
            size="custom"
            customVarsStyles={cn(
                classes["avatars-description"],
                classes[`__size-${size}`],
            )}
            data-tsid={AVATARS_VIEW_LINK_TEST_ID}
        >
            {children}
        </Link>
    );
};

AvatarsViewLink.displayName = "AvatarsView.Link";

export default AvatarsViewLink;
